module.exports = __webpack_public_path__ + "static/bg02-ccd43ec7230f6b2b5fc9a64318dda607.jpg";